var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCorrectingBox = function SvgCorrectingBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#correcting_box_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    d: "M20.8 0H0v24.108L6 19H0h20.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C24 17.48 24 16.92 24 15.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C22.48 0 21.92 0 20.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 4.333c0-.369.298-.667.667-.667h8c.368 0 .666.298.666.667v3.69a2.666 2.666 0 0 1 .818 3.886l1.816 2.114a.667.667 0 1 1-.943.943l-1.69-1.969v1.336a.667.667 0 0 1-.667.666h-8A.667.667 0 0 1 7 14.333zm8 8.666a2.67 2.67 0 0 1-2.31-1.333H9.667a.667.667 0 0 1 0-1.333h2.666q.002-.346.084-.667h-2.75a.667.667 0 0 1 0-1.333H13q.106 0 .202.03A2.66 2.66 0 0 1 15 7.667V4.999H8.333v8.667H15zM9.667 6.333a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333zM15 11.666a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "correcting_box_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCorrectingBox;